
import { useState } from 'react';

export default function GetStartedSection() {
  const [formData, setFormData] = useState({
    firstName: '',
    lastName: '',
    email: '',
    phone: '',
    address: '',
    unit: '',
    city: '',
    state: '',
    zip: '',
    propertyType: ''
  });
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitStatus, setSubmitStatus] = useState<'idle' | 'success' | 'error'>('idle');

  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handlePropertyTypeChange = (type: string) => {
    setFormData(prev => ({
      ...prev,
      propertyType: type
    }));
  };

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setIsSubmitting(true);
    setSubmitStatus('idle');

    try {
      const formBody = new URLSearchParams();
      Object.entries(formData).forEach(([key, value]) => {
        formBody.append(key, value);
      });

      const response = await fetch('https://readdy.ai/forms/submit/3a32c659-d17f-4d12-b3b9-7e8f4a5b2c9d', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
        },
        body: formBody.toString()
      });

      if (response.ok) {
        setSubmitStatus('success');
        setFormData({
          firstName: '',
          lastName: '',
          email: '',
          phone: '',
          address: '',
          unit: '',
          city: '',
          state: '',
          zip: '',
          propertyType: ''
        });
      } else {
        setSubmitStatus('error');
      }
    } catch (error) {
      setSubmitStatus('error');
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <section className="w-full scroll-mt-10 bg-[#f8f8f0]" id="prequalify-section">
      <div className="container mx-auto py-8 md:py-16 px-12">
        <div>
          <h2 className="text-center text-3xl md:text-5xl 2xl:text-6xl font-semibold tracking-tight text-blue-900">
            Get started
          </h2>
        </div>
        <p className="text-center text-xl md:text-3xl text-orange-500 max-w-3xl mx-auto md:mt-2 origin-center">
          Join our waitlist with no obligation
        </p>
        
        <div className="mt-10 md:mt-20 prose dark:prose-invert max-w-none">
          <div className="bg-white border-1 border-orange-500 max-w-4xl mx-auto flex flex-col gap-4 rounded-2xl p-5 md:p-8 shadow-[0px_5px_35px_-1px_rgba(52,31,0,0.3)]">
            <div>
              <p>It's fast and simple to start—there's <strong>no credit check and no commitment.</strong></p>
              <p>The RealRises Bitcoin Investment Partnership is available in the U.S. only.</p>
            </div>
            
            <form 
              className="space-y-3 md:space-y-4 max-w-4xl mx-auto" 
              onSubmit={handleSubmit}
              data-readdy-form
              id="waitlist-form"
            >
              <div className="grid grid-cols-2 gap-4">
                <div className="col-span-1">
                  <label className="flex items-center font-medium text-sm gap-0.5">
                    First name<span className="text-red-500 font-black">*</span>
                  </label>
                  <input
                    className="bg-gradient-to-b from-[#f9f9f9] to-[#fafafa] shadow-[inset_0px_0px_1px_0_rgba(0,0,0,.1)] h-9 md:h-12 text-base md:text-xl placeholder-[#ccc] p-1 md:p-2 rounded-lg border border-gray-300 w-full focus-border-orange-500 focus:ring-1 focus:ring-orange-500 outline-none"
                    placeholder="Satoshi"
                    name="firstName"
                    value={formData.firstName}
                    onChange={handleInputChange}
                    required
                  />
                </div>
                <div className="col-span-1">
                  <label className="flex items-center font-medium text-sm gap-0.5">
                    Last name<span className="text-red-500 font-black">*</span>
                  </label>
                  <input
                    className="bg-gradient-to-b from-[#f9f9f9] to-[#fafafa] shadow-[inset_0px_0px_1px_0_rgba(0,0,0,.1)] h-9 md:h-12 text-base md:text-xl placeholder-[#ccc] p-1 md:p-2 rounded-lg border border-gray-300 w-full focus:border-orange-500 focus:ring-1 focus:ring-orange-500 outline-none"
                    placeholder="Nakamoto"
                    name="lastName"
                    value={formData.lastName}
                    onChange={handleInputChange}
                    required
                  />
                </div>
              </div>
              
              <div className="grid grid-cols-2 gap-4">
                <div className="col-span-1">
                  <label className="flex items-center font-medium text-sm gap-0.5">
                    Email<span className="text-red-500 font-black">*</span>
                  </label>
                  <input
                    type="email"
                    className="bg-gradient-to-b from-[#f9f9f9] to-[#fafafa] shadow-[inset_0px_0px_1px_0_rgba(0,0,0,.1)] h-9 md:h-12 text-base md:text-xl placeholder-[#ccc] p-1 md:p-2 rounded-lg border border-gray-300 w-full focus:border-orange-500 focus:ring-1 focus:ring-orange-500 outline-none"
                    name="email"
                    value={formData.email}
                    onChange={handleInputChange}
                    required
                  />
                </div>
                <div className="col-span-1">
                  <label className="flex items-center font-medium text-sm gap-0.5">
                    Phone
                  </label>
                  <input
                    type="tel"
                    className="bg-gradient-to-b from-[#f9f9f9] to-[#fafafa] shadow-[inset_0px_0px_1px_0_rgba(0,0,0,.1)] h-9 md:h-12 text-base md:text-xl placeholder-[#ccc] p-1 md:p-2 rounded-lg border border-gray-300 w-full focus:border-orange-500 focus:ring-1 focus:ring-orange-500 outline-none"
                    name="phone"
                    value={formData.phone}
                    onChange={handleInputChange}
                  />
                </div>
              </div>
              
              <div className="grid grid-cols-10 gap-4">
                <div className="col-span-8">
                  <label className="flex items-center font-medium text-sm gap-0.5">
                    Address<span className="text-red-500 font-black">*</span>
                  </label>
                  <input
                    className="bg-gradient-to-b from-[#f9f9f9] to-[#fafafa] shadow-[inset_0px_0px_1px_0_rgba(0,0,0,.1)] h-9 md:h-12 text-base md:text-xl placeholder-[#ccc] p-1 md:p-2 rounded-lg border border-gray-300 w-full focus:border-orange-500 focus:ring-1 focus:ring-orange-500 outline-none"
                    name="address"
                    value={formData.address}
                    onChange={handleInputChange}
                    required
                  />
                </div>
                <div className="col-span-2">
                  <label className="flex items-center font-medium text-sm gap-0.5">
                    Unit
                  </label>
                  <input
                    className="bg-gradient-to-b from-[#f9f9f9] to-[#fafafa] shadow-[inset_0px_0px_1px_0_rgba(0,0,0,.1)] h-9 md:h-12 text-base md:text-xl placeholder-[#ccc] p-1 md:p-2 rounded-lg border border-gray-300 w-full focus:border-orange-500 focus:ring-1 focus:ring-orange-500 outline-none"
                    name="unit"
                    value={formData.unit}
                    onChange={handleInputChange}
                  />
                </div>
              </div>
              
              <div className="grid grid-cols-5 gap-4">
                <div className="col-span-2">
                  <label className="flex items-center font-medium text-sm gap-0.5">
                    City<span className="text-red-500 font-black">*</span>
                  </label>
                  <input
                    className="bg-gradient-to-b from-[#f9f9f9] to-[#fafafa] shadow-[inset_0px_0px_1px_0_rgba(0,0,0,.1)] h-9 md:h-12 text-base md:text-xl placeholder-[#ccc] p-1 md:p-2 rounded-lg border border-gray-300 w-full focus:border-orange-500 focus:ring-1 focus:ring-orange-500 outline-none"
                    name="city"
                    value={formData.city}
                    onChange={handleInputChange}
                    required
                  />
                </div>
                <div className="col-span-1">
                  <label className="flex items-center font-medium text-sm gap-0.5">
                    State<span className="text-red-500 font-black">*</span>
                  </label>
                  <input
                    className="bg-gradient-to-b from-[#f9f9f9] to-[#fafafa] shadow-[inset_0px_0px_1px_0_rgba(0,0,0,.1)] h-9 md:h-12 text-base md:text-xl placeholder-[#ccc] p-1 md:p-2 rounded-lg border border-gray-300 w-full focus:border-orange-500 focus:ring-1 focus:ring-orange-500 outline-none"
                    maxLength={2}
                    name="state"
                    value={formData.state}
                    onChange={handleInputChange}
                    required
                  />
                </div>
                <div className="col-span-2">
                  <label className="flex items-center font-medium text-sm gap-0.5">
                    Zip<span className="text-red-500 font-black">*</span>
                  </label>
                  <input
                    className="bg-gradient-to-b from-[#f9f9f9] to-[#fafafa] shadow-[inset_0px_0px_1px_0_rgba(0,0,0,.1)] h-9 md:h-12 text-base md:text-xl placeholder-[#ccc] p-1 md:p-2 rounded-lg border border-gray-300 w-full focus:border-orange-500 focus:ring-1 focus:ring-orange-500 outline-none"
                    maxLength={5}
                    name="zip"
                    value={formData.zip}
                    onChange={handleInputChange}
                    required
                  />
                </div>
              </div>
              
              <div className="grid grid-cols-1 mb-0">
                <div className="flex flex-col md:flex-row md:items-center gap-2">
                  <div className="whitespace-nowrap">
                    This property is a <span className="text-red-500 font-black">*</span>
                  </div>
                  <div className="flex flex-col md:flex-row gap-3 py-3 px-4">
                    {[
                      { value: 'PRIMARY_RESIDENCE', label: 'primary residence' },
                      { value: 'SECONDARY_RESIDENCE', label: 'secondary residence' },
                      { value: 'INVESTMENT_PROPERTY', label: 'investment property' }
                    ].map((option) => (
                      <div key={option.value} className="flex items-center space-x-2">
                        <button
                          type="button"
                          onClick={() => handlePropertyTypeChange(option.value)}
                          className={`aspect-square size-4 shrink-0 rounded-full border shadow-xs transition-all outline-none cursor-pointer ${
                            formData.propertyType === option.value
                              ? 'border-orange-500 bg-orange-500'
                              : 'border-gray-300 bg-white hover:border-orange-400'
                          }`}
                        >
                          {formData.propertyType === option.value && (
                            <div className="w-full h-full rounded-full bg-white scale-50"></div>
                          )}
                        </button>
                        <label className="cursor-pointer" onClick={() => handlePropertyTypeChange(option.value)}>
                          {option.label}
                        </label>
                      </div>
                    ))}
                  </div>
                </div>
              </div>
              
              <div className="col-span-1">
                <button
                  type="submit"
                  disabled={isSubmitting}
                  className={`shadow-[0px_1px_1.5px_0px_rgba(0,0,0,0.1)] border-t-1 border-t-white/20 border-b-1 border-b-black/10 inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md text-base font-light transition-all outline-none w-full mt-4 h-9 px-4 py-5 cursor-pointer ${
                    isSubmitting
                      ? 'bg-gray-300 text-gray-800 cursor-not-allowed'
                      : 'bg-gradient-to-b from-orange-500 to-orange-600 text-white hover:text-gray-100 active:from-orange-600 active:to-orange-500'
                  }`}
                >
                  {isSubmitting ? 'Submitting...' : 'Submit'}
                </button>
              </div>
              
              <div className="text-center">
                {submitStatus === 'success' && (
                  <p className="text-green-600 text-sm">Thank you! Your information has been submitted successfully.</p>
                )}
                {submitStatus === 'error' && (
                  <p className="text-red-600 text-sm">There was an error submitting your information. Please try again.</p>
                )}
              </div>
            </form>
            
            <p className="text-center text-sm text-gray-500">
              By submitting, you agree to our{' '}
              <a className="hover:text-orange-500 cursor-pointer" href="/privacy-policy">
                Privacy Policy
              </a>{' '}
              and consent to receive communications from RealRises
            </p>
            
            <div className="mt-8 text-center">
              Have a question? Reach out to us at{' '}
              <span className="tracking-normal font-bold">team.realrises@gmail.com</span>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
